import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const API = "https://reflex-backend.alfaoir1.workers.dev";

export default function AdminProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = (isRetry = false) => {
      fetch(`${API}/applications/${id}`)
        .then((r) => r.json())
        .then((res) => {
          if (res.success) setData(res.applicant);
          else setError("Applicant not found.");
          setLoading(false);
        })
        .catch(() => {
          if (!isRetry) {
            setTimeout(() => fetchData(true), 1000);
          } else {
            setError("Could not connect to backend.");
            setLoading(false);
          }
        });
    };
    fetchData();
  }, [id]);

  if (loading) return <div style={s.page}><p style={s.msg}>Loading...</p></div>;
  if (error) return <div style={s.page}><p style={s.err}>{error}</p></div>;

  return (
    <div style={s.page}>
      <div style={s.header}>
        <button onClick={() => navigate("/admin/hiring")} style={s.back}>← Back to Dashboard</button>
        <div style={s.profileRow}>
          <div style={s.avatar}>{((data.name || data.fullName || "?")[0]).toUpperCase()}</div>
          <div>
            <h1 style={s.name}>{data.name || data.fullName || "—"}</h1>
            <p style={s.email}>{data.email || "—"}</p>
            {data.createdAt && <p style={s.date}>Applied on {new Date(data.createdAt).toLocaleString()}</p>}
          </div>
        </div>
      </div>

      <div style={s.content}>

        <Block title="Personal Information">
          <Row label="Full Name" value={data.name || data.fullName} />
          <Row label="Email" value={data.email} />
          <Row label="Phone" value={data.phone} />
          <Row label="Address" value={data.address} />
          <Row label="Expected Salary" value={data.expectedSalary || data.salary} />
        </Block>

        <Block title="Availability & Setup">
          <Row label="Availability" value={data.availability} />
          <Row label="Internet Speed" value={data.internetSpeed} />
          <Row label="Laptop" value={data.laptopName || data.laptopModel} />
          <Row label="Headphone" value={data.headphoneName || data.headphoneModel} />
        </Block>

        <Block title="Documents">
          <div style={s.docRow}>
            <span style={s.docLabel}>CV / Resume</span>
            {data.cvFileUrl || data.cvKey
              ? <a href={data.cvFileUrl || data.cvKey} target="_blank" rel="noreferrer" style={s.link}>View / Download ↗</a>
              : <span style={s.noDoc}>Not uploaded</span>}
          </div>
          <div style={s.docRow}>
            <span style={s.docLabel}>Identity Card</span>
            {data.idCardFileUrl || data.idCardKey
              ? <a href={data.idCardFileUrl || data.idCardKey} target="_blank" rel="noreferrer" style={s.link}>View / Download ↗</a>
              : <span style={s.noDoc}>Not uploaded</span>}
          </div>
        </Block>

      </div>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div style={{ marginBottom: "28px" }}>
      <p style={{ fontSize: "11px", fontWeight: 700, color: "#a855f7", textTransform: "uppercase", letterSpacing: "2px", marginBottom: "12px" }}>{title}</p>
      <div style={{ border: "1px solid #1f1f2e", borderRadius: "12px", overflow: "hidden" }}>{children}</div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "13px 18px", borderBottom: "1px solid #1f1f2e", gap: "20px" }}>
      <span style={{ fontSize: "13px", color: "#6b7280", flexShrink: 0 }}>{label}</span>
      <span style={{ fontSize: "14px", color: "#e5e7eb", textAlign: "right" }}>{value || "—"}</span>
    </div>
  );
}

const s = {
  page: { background: "#0a0a0f", minHeight: "100vh", color: "#fff", fontFamily: "Inter, sans-serif" },
  header: { background: "linear-gradient(135deg, #0f0a1e, #1a0d2e)", padding: "40px", borderBottom: "1px solid #1f1f2e" },
  back: { background: "rgba(255,255,255,0.05)", border: "1px solid #2a2a3e", color: "#9ca3af", borderRadius: "8px", padding: "8px 16px", cursor: "pointer", fontSize: "13px", marginBottom: "28px", fontFamily: "Inter, sans-serif" },
  profileRow: { display: "flex", alignItems: "center", gap: "20px" },
  avatar: { width: "60px", height: "60px", background: "linear-gradient(135deg, #7c3aed, #a855f7)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "24px", fontWeight: 700, flexShrink: 0 },
  name: { fontSize: "26px", fontWeight: 800, margin: "0 0 4px", letterSpacing: "-0.02em" },
  email: { fontSize: "14px", color: "#9ca3af", margin: "0 0 4px" },
  date: { fontSize: "12px", color: "#6b7280", margin: 0 },
  content: { maxWidth: "680px", margin: "0 auto", padding: "40px 20px" },
  docRow: { display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 18px", borderBottom: "1px solid #1f1f2e" },
  docLabel: { fontSize: "13px", color: "#6b7280" },
  link: { color: "#a855f7", fontSize: "14px", textDecoration: "none" },
  noDoc: { fontSize: "14px", color: "#374151" },
  msg: { color: "#6b7280", textAlign: "center", paddingTop: "100px" },
  err: { color: "#ef4444", textAlign: "center", paddingTop: "100px" },
};